/* global DPI_STATS_TMOUT_MS */
import React, { useState, useEffect, useContext } from "react";
import Request from "common/Request";
import Result from "./Result";
import { parseRootUsage } from "./api";
import ActionsContext from "common/ActionsContext";
import { splitClusterResponse } from "common/api";
import styled from "styled-components";
import View from "common/View";
import useDebouncer from "common/hooks/debouncer";
import * as d3 from "d3";

const LOAD_INTERVAL = 3000;

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li>
        <a
          onClick={() => {
            actions.send("do-load");
          }}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
    </ul>
  );
};

function parseResponse(input) {
  const parts = splitClusterResponse(input);
  return {
    usage: parts.map((part) => {
      const usage = parseRootUsage(part.resp);
      return { bqnId: part.bqnId, ...usage };
    }),
  };
}

const diskUsageRetrieval = () =>
  ifCl.run("show system filesystem").then(parseResponse);

const Report = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const [liveData, setLiveData] = useState(null);

  const debounce = useDebouncer(500 /*ms*/);

  useEffect(() => {
    let active = true;

    const doLoad = () => {
      const req = diskUsageRetrieval().then((data) => {
        if (active) setLiveData(data);
        return data;
      });
      setRequest(req);
    };

    const doBackgroundLoad = () => {
      diskUsageRetrieval()
        .then((data) => {
          if (active) setLiveData(data);
        })
        .catch((err) => console.error("Disk background fetch failed:", err));
    };

    doLoad();
    const intervalId = setInterval(doBackgroundLoad, LOAD_INTERVAL);
    const unsubscribe = actions.recv("do-load", () => debounce(doLoad));

    return () => {
      active = false;
      clearInterval(intervalId);
      unsubscribe();
      debounce.stop();
    };
  }, [debounce]);

  return (
    <Request during={request}>
      {() => (liveData ? <Result data={liveData} /> : null)}
    </Request>
  );
};

const DiskStatus = () => (
  <View title="Disk Usage">
    <Report />
  </View>
);
export default DiskStatus;
